export default __webpack_public_path__ + "static/media/18.b87adfe0.jpg";